const nl = {
  layout: {
    cos_button: {
      phone: 'Telefoon',
      update_phone_number_message: 'Telefoonnummer is met succes bijgewerkt!'
    },
    time: {
      days: 'Dagen',
      hours: 'Uren',
      mins: 'Minuten',
      secs: 'Seconden',
      starts: 'Start',
      starts_immediately: 'Begint Onmiddellijk'
    },
    field: {
      host: 'Host'
    },
    copy: 'Kopiëren'
  },
  validations: {
    email: 'moet een geldig email zijn',
    phone: 'moet een geldige telefoon zijn',
    required_field: 'is een verplicht veld'
  },
  mailer: {
    need_help: 'Hulp Nodig?',
    stop_reminders: 'Stop met herinneringen te ontvangen',
    cancel_registration: 'Annuleer registratie',
    report_abuse: 'Misbruik melden'
  },
  datetime: {
    no_sessions: 'Geen sessies beschikbaar',
    empty_label: 'Datum/tijd'
  },
  errors: {
    verification_failed: 'Verificatie mislukt. Probeer het opnieuw.',
    session_unavailable: 'Het door u geselecteerde tijdstip is niet meer beschikbaar. Kies een ander tijdstip.',
    challenge_email_mismatch: 'Registreer met hetzelfde e-mailadres dat u voor het evenement hebt gebruikt.'
  }
}

export default nl
